import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { updateTaskSimple } from '../../../../../../../../../app/page/page-storage/tasks-simple/tasks-simple.actions';
import { taskSimpleSelectors } from '../../../../../../../../../app/resource/task-simple/task-simple.selectors';
import { userSelectors } from '../../../../../../../../../app/resource/user/user.selectors';
import { useSelectWithParams } from '../../../../../../../../../utils/selector.utils';
import { IMemberProps } from './types';
import { CircularAvatar } from '../../../../../../CustomAvatar';

export const Member: FunctionComponent<IMemberProps> = ({ userId, taskId, setIsErrorMode }) => {
  const user = useSelectWithParams(userSelectors.selectResourceById, userId);
  const task = useSelectWithParams(taskSimpleSelectors.selectResourceById, taskId);

  const taskMembers = useMemo(() => {
    return task?.members ?? [];
  }, [task]);

  const [isSelected, setSelected] = useState(false);

  useEffect(() => {
    const membersFiltered = user ? taskMembers.filter((taskMember) => taskMember === user.id) : [];
    setSelected(!!membersFiltered.length);
  }, [taskMembers, user]);

  const dispatch = useDispatch();

  const addTaskMember = useCallback(() => {
    if (task && user) {
      dispatch(
        updateTaskSimple(task.id, {
          members: [...task.members, user.id],
        }),
      );
    }
  }, [dispatch, task, user]);

  const deleteTaskMember = useCallback(() => {
    if (task && user) {
      const updatedTask = {
        id: task.id,
        title: task.title,
        description: task.description,
        dueDate: task.dueDate,
        userId: task.userId,
        meetingIds: task.meetingIds,
        status: task.status,
        label: task?.labels ? task.labels : [],
        taskTypeId: task.taskTypeId,
        members: task.members.filter((taskMember) => taskMember !== user.id),
        showInTasks: task.showInTasks,
        boardId: task.boardId,
      };
      dispatch(updateTaskSimple(updatedTask.id, updatedTask));
    }
  }, [dispatch, task, user]);

  const isActionItem = task?.showInTasks === '1';
  const onlyOneUserAssigned = task?.members.length === 1;

  const toggleSelect = useCallback(() => {
    if (isSelected) {
      if (onlyOneUserAssigned && isActionItem) {
        setIsErrorMode(true);
      } else {
        deleteTaskMember();
        setSelected(!isSelected);
      }
    } else {
      addTaskMember();
      setSelected(!isSelected);
    }
  }, [addTaskMember, deleteTaskMember, isSelected, setIsErrorMode, isActionItem, onlyOneUserAssigned]);

  return (
    user && (
      <div className={isSelected ? 'one-member selected' : 'one-member'} onClick={toggleSelect}>
        <CircularAvatar
          src={user.image}
          title={`${user.firstName} ${user.lastName}`}
          classes="small-avatar img-fluid mr-1"
        />
        {`${user.firstName} ${user.lastName}`}
      </div>
    )
  );
};
